// @ts-check
import React from 'react';

/**
 * Shared empty state component for StudentDashboard tabs.
 * Unifies the 4 different CSS class names (empty-state, empty-state-large,
 * daily-empty, map-empty) into a single component with size variants.
 *
 * @param {Object} props
 * @param {string} props.mascot - Emoji string (e.g. '🐑🔍')
 * @param {string} [props.mascotStyle] - Animation class: 'exploring', 'reading', 'celebrating'
 * @param {string} props.title
 * @param {string} [props.subtitle]
 * @param {'small' | 'default' | 'large'} [props.size] - Size variant (default: 'default')
 */
function EmptyState({ mascot, mascotStyle, title, subtitle, size = 'default' }) {
  const sizeClass = size === 'default' ? '' : ` empty-state--${size}`;
  const illustrationSize = size === 'small' ? ' small' : '';

  return (
    <div className={`empty-state illustrated${sizeClass}`}>
      <div className={`empty-illustration${illustrationSize}`}>
        <div className={`empty-mascot${mascotStyle ? ` ${mascotStyle}` : ''}`}>{mascot}</div>
      </div>
      <p className="empty-title">{title}</p>
      {subtitle && <p className="empty-subtitle">{subtitle}</p>}
    </div>
  );
}

export default EmptyState;
